import { Plugin } from 'ckeditor5'

class CustomDropMarkerPositioning extends Plugin {
  init() {
    const editor = this.editor
    const clipboardPlugin = editor.plugins.get('Clipboard')

    // Ensure the clipboard plugin is available
    if (clipboardPlugin) {
      // Access the editing view document to add custom drag event listeners
      const viewDocument = editor.editing.view.document

      // Add a dragover listener
      viewDocument.on('dragover', (_event, data) => {
        // Prevent default behavior to allow drop
        data.preventDefault()

        const clipboardDropTargetLine = document.querySelector(
          '.ck-clipboard-drop-target-line',
        )

        const editorContainerInline = document.querySelector(
          '.ck-editor__editable_inline',
        )

        if (
          clipboardDropTargetLine &&
          editorContainerInline &&
          clipboardDropTargetLine.style.marginTop != '1px'
        ) {
          const markerTop = parseInt(clipboardDropTargetLine.style.top)
          const editorMinHeight =
            parseInt(getComputedStyle(editorContainerInline).minHeight) - 100
          if (markerTop && markerTop < editorMinHeight) {
            let newPosition =
              markerTop - (editorContainerInline.offsetHeight - markerTop)

            // Adjust the position of the drop marker directly.
            clipboardDropTargetLine.style.top = `${parseInt(newPosition)}px`
            // Add to margin for just adjust one time check
            clipboardDropTargetLine.style.marginTop = `1px`
          }
        }
      })

      // Auto-scroll while dragging near viewport edges.
      //
      // We use a native DOM listener for two reasons:
      //   1. CKEditor's view dragover event wrapper does not reliably expose
      //      clientY across versions.
      //   2. Proximity is measured against the viewport (0 / innerHeight),
      //      not an element bounding rect — that value goes negative once
      //      the page is scrolled, which breaks the upward check.
      //
      // The scroll itself runs in a requestAnimationFrame loop rather than
      // directly inside dragover. Browsers only fire dragover while the
      // cursor moves; a user who parks the cursor in the edge zone would
      // otherwise see scroll halt. The rAF loop keeps scrolling as long as
      // the last-seen cursor position stayed in the zone.

      this._scrollDirection = 0
      this._scrollRafId = null

      const tickScroll = () => {
        if (this._scrollDirection === 0) {
          this._scrollRafId = null
          return
        }
        const speed = 7
        const dy = this._scrollDirection * speed

        window.scrollBy(0, dy)
        if (document.scrollingElement) {
          document.scrollingElement.scrollTop += dy
        }

        const editable = document.querySelector('.ck-editor__editable')
        if (editable) {
          let el = editable.parentElement
          while (el && el !== document.body) {
            const style = getComputedStyle(el)
            if (/(auto|scroll)/.test(style.overflowY)) {
              el.scrollTop += dy
            }
            el = el.parentElement
          }
        }

        this._scrollRafId = requestAnimationFrame(tickScroll)
      }

      this._onDocumentDragOver = e => {
        if (!document.querySelector('.ck-editor__editable')) return

        const threshold = 150
        if (e.clientY < threshold) {
          this._scrollDirection = -1
        } else if (window.innerHeight - e.clientY < threshold) {
          this._scrollDirection = 1
        } else {
          this._scrollDirection = 0
        }

        if (this._scrollDirection !== 0 && this._scrollRafId === null) {
          this._scrollRafId = requestAnimationFrame(tickScroll)
        }
      }

      this._stopAutoScroll = () => {
        this._scrollDirection = 0
        if (this._scrollRafId !== null) {
          cancelAnimationFrame(this._scrollRafId)
          this._scrollRafId = null
        }
      }

      // Capture phase so we run before any handler that might stop
      // propagation of the dragover event.
      document.addEventListener('dragover', this._onDocumentDragOver, true)
      document.addEventListener('drop', this._stopAutoScroll, true)
      document.addEventListener('dragend', this._stopAutoScroll, true)

      viewDocument.on('drop', (event, data) => {
        // Prevent default behavior to allow drop
        data.preventDefault()

        // You can now read from clipboard data as needed

        const clipboardDropTargetLine = document.querySelector(
          '.ck-clipboard-drop-target-line',
        )

        // Clear drag amrker position
        if (
          clipboardDropTargetLine &&
          clipboardDropTargetLine.style.marginTop == '1px'
        ) {
          const top = clipboardDropTargetLine.style.top
          if (top) {
            clipboardDropTargetLine.style.marginTop = `0px`
            clipboardDropTargetLine.style.top = null
          }
        }
      })
    } else {
      console.warn('Clipboard plugin not available.')
    }
  }
}

export default CustomDropMarkerPositioning
